export default {"src":"/_next/static/media/close-icon.e8ddfb1e.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};